import { z } from "zod";

export const specificationSchema = z.object({
  circuitBreakerPhaseSod: z.number().nullable(),
  circuitBreakerPhaseSop: z.number().nullable(),
  circuitBreakerValueSod: z.number().nullable(),
  circuitBreakerValueSop: z.number().nullable(),
  city: z.string().nullable(),
  cityPart: z.string().nullable(),
  code: z.string().nullable(),
  company: z.string().nullable(),
  companyType: z.string().nullable(),
  connectionType: z.string().nullable(),
  deviceInstalled: z.boolean().default(false),
  evidenceNumber: z.string().nullable(),
  expectedConstructionDate: z.string().nullable(),
  factory: z.boolean().nullable(),
  hdv: z.boolean().nullable(),
  houseNumber: z.string().nullable(),
  latest: z.boolean().default(false),
  location: z.boolean().default(false),
  measurementCategory: z.number().nullable(),
  measurementType: z.string().nullable(),
  mtp: z.boolean().default(false),
  name: z.string().nullable(),
  operatorConnection: z.string().nullable(),
  operatorConstruction: z.string().nullable(),
  opmDisconnected: z.boolean().default(false),
  opmReady: z.boolean().default(false),
  parcelNumber: z.string().nullable(),
  parcelPart: z.string().nullable(),
  rank: z.number().default(0),
  relevantProcesses: z.string().nullable(),
  reservationDate: z.string().nullable(),
  rsNote: z.string().nullable(),
  sopNote: z.string().nullable(),
  street: z.string().nullable(),
  streetNumber: z.string().nullable(),
  supplierAssigned: z.boolean().default(false),
  surname: z.string().nullable(),
  technicalApprovalRequest: z.boolean().nullable(),
  trippingCharacteristic: z.string().nullable(),
  voltageLevel: z.string().nullable(),
  zip: z.string().nullable(),
  cadastralTerritoryId: z.number().nullable(),
  customerId: z.string().nullable(),
  customerTypeId: z.number().nullable(),
  id: z.number(),
});
